import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from '../rootReducer';
import {
    LOAD_WHITE_LABEL_STYLES_FAIL,
    LOAD_WHITE_LABEL_STYLES_REQUEST,
    LOAD_WHITE_LABEL_STYLES_SUCCESS,
} from '../modules/actions';
import { WhiteLabelStyle } from '../../types/WhiteLabel';
import theme from '@liveauctioneers/caterwaul-components/lib/theme/theme';

export const defaultWhiteLabelStyle: WhiteLabelStyle = {
    property: 'primaryColor',
    value: theme.colors.blue100,
};

// reducer
export const DEFAULT_STATE = {
    hostname: '',
    isWhiteLabel: false,
    loading: false,
    logo: '',
    name: '',
    sellerId: 0,
    siteName: '',
    siteUrl: '',
    styles: [defaultWhiteLabelStyle],
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_WHITE_LABEL_STYLES_FAIL:
            return {
                ...state,
                loading: false,
                styles: [defaultWhiteLabelStyle],
            };
        case LOAD_WHITE_LABEL_STYLES_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case LOAD_WHITE_LABEL_STYLES_SUCCESS:
            let newWhiteLabelStyles =
                action.payload && action.payload.length > 0 ? action.payload : [defaultWhiteLabelStyle];

            return {
                ...state,
                loading: false,
                styles: newWhiteLabelStyles,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.whiteLabel;

export const getHostName = createSelector(stateSelector, (state) => {
    return state ? state.hostname : '';
});

export const getWhiteLabelLogo = createSelector(stateSelector, (state) => state.logo);
export const getWhiteLabelName = createSelector(stateSelector, (state) => state.name);
export const getWhiteLabelSellerId = createSelector(stateSelector, (state) => state.sellerId);
export const getWhiteLabelSiteName = createSelector(stateSelector, (state) => state.siteName);
export const getWhiteLabelSiteUrl = createSelector(stateSelector, (state) => {
    if (Boolean(state.siteUrl) && !state.siteUrl.includes('http')) {
        return `//${state.siteUrl}`;
    }
    return state.siteUrl;
});
export const getWhiteLabelStyles = createSelector(stateSelector, (state) => state.styles);
export const getWhiteLabelPrimaryColor = createSelector(stateSelector, (state) => {
    let whiteLabelStyles = state.styles ? state.styles : [];
    let primaryColor = [...whiteLabelStyles].filter(({ property }) => property === 'primaryColor');
    if (primaryColor.length <= 0) {
        return theme.colors.blue100;
    } else {
        return primaryColor[0].value;
    }
});
export const getIsWhiteLabel = createSelector(stateSelector, (state) => Boolean(state.isWhiteLabel));
